import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App";

import ApolloClient from "apollo-boost";

// global flag to determine if a component was mounted
let __MOUNTED__ = false;

const wrappedComponent = (component) => (
    <App>{component}</App>
);

export function register(view, component) {
    // find element by it's ID
    let element = document.getElementById(`react::${view}`);
    let legacy = false;

    if ( !element && view === 'legacy') {
        element = document.getElementById(`app`);
        legacy = true;
    }


    if (element) {
        window.apolloClient = new ApolloClient({
        });

        // create new props object with server rendered __DATA__
        const props = Object.assign({},
            window.__DATA__
        );

        // create a react component node with properties
        const node = wrappedComponent(
            React.createElement(component, props)
        );

        // mount our page component there
        ReactDOM.render(node, element);

        // if ( legacy ) {
        //     debugger;
        //     let sidebar = React.createElement(wrappedComponent(require('./components/Navigation/Navigation').default, {items:window.__DATA__._menu}));
        //     let sidebarDom = document.getElementById(`sidebar`);
        //     ReactDOM.render(sidebar, sidebarDom);
        // }

        // indicate that a component was mounted
        __MOUNTED__ = true;
    }

    window.apolloClientQuery = async function(query){
        return new Promise((resolve, reject)=>{
            const sub  = window.apolloClient
                .watchQuery({query})
                .subscribe(({data, loading, networkStatus, stale}) => {
                    sub.unsubscribe();
                    resolve(data);
                });
        });
    }
}

export const handlePageNotFound = () => {
    if (!__MOUNTED__) {
        throw new Error('No react page for your given laravel view defined. Did you \'register\' it in the app entry point?');
    }
};
